import {Modal} from "antd";
import React from "react";
import {connect} from "react-redux";
import {bindActionCreators, Dispatch} from "redux";
import {setMe} from "../../../core/app/setMe/actions";
import {setModalVisibility} from "../../../core/app/setModalVisibility/actions";
import {ModalType} from "../../../core/models/custom/enums/modalType";
import {ModalVisibilityPayload} from "../../../core/models/custom/modalVisibility.payload";
import {MeDto} from "../../../core/models/dtos/me.dto";
import {Popup} from "../../../core/models/enums/popup";
import {seePopup} from "../../../core/services/userService/seePopup/actions";
import {SeePopupState} from "../../../core/services/userService/seePopup/types";
import ContentKeys from "../../../core/utilities/contentKeys";
import {Images} from "../../../core/utilities/images";
import {IStore} from "../../../core/utilities/reducers";
import {UI} from "../../../core/utilities/ui";
import AppButton from "../../Buttons/AppButton/AppButton";
import ContentKey from "../../ContentKey/ContentKey";
import Reward from "../Common/Reward/Reward";
import "./MonthlyModal.scss";

interface IProps {
  me?: MeDto;
  seePopupState: SeePopupState;
  setMe: (me?: MeDto) => void;
  seePopup: (popup: Popup) => void;
  setModalVisibility: (payload: ModalVisibilityPayload) => void;
}

class MonthlyModal extends React.Component<IProps> {
  private readonly modal = ModalType.MONTHLY;
  
  componentDidMount() {
    this.props.seePopup(Popup.WINNER);
  }
  
  componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<{}>, snapshot?: any) {
    if (prevProps.seePopupState.loading && !this.props.seePopupState.loading) {
      if (this.props.seePopupState.data) {
        const me = this.props.me;
        if (me) {
          me.shouldSeeWinner = false;
          this.props.setMe(me);
        }
      }
    }
  }
  
  private isGold(): boolean {
    if (!this.props.me?.lastWinnerRank) return false;
    return this.props.me.lastWinnerRank <= 20;
  }
  
  private handleModalClose(): void {
    this.props.setModalVisibility({modal: this.modal, isVisible: false});
  }
  
  render() {
    return (
      <Modal
        className="monthly-modal"
        maskStyle={UI.modalMaskStyle()}
        open
        closable={false}
        footer={false}
        centered
        destroyOnClose
      >
        <div className="body">
          <img className="coins" src={this.isGold() ? Images.coins_gold : Images.coins_silver} alt="coins"/>
          <div className="rank-wrapper">
            <img className="star" src={this.isGold() ? Images.star_gold : Images.star_silver} alt="star"/>
            <span className="rank">{this.props.me?.lastWinnerRank}</span>
          </div>
          
          <Reward
            rewardKey={this.isGold() ? ContentKeys.WINNER_POPUP_TOP20_REWARD : ContentKeys.WINNER_POPUP_TOP100_REWARD}
          />
          
          <ContentKey
            className="title link-medium"
            contentKey={this.isGold() ? ContentKeys.WINNER_POPUP_TOP20_TITLE : ContentKeys.WINNER_POPUP_TOP100_TITLE}
          />
          
          <ContentKey
            className="text text-medium"
            contentKey={this.isGold() ? ContentKeys.WINNER_POPUP_TOP20_TEXT : ContentKeys.WINNER_POPUP_TOP100_TEXT}
          />
          
          <AppButton
            text={
              <ContentKey
                contentKey={this.isGold() ? ContentKeys.WINNER_POPUP_TOP20_BUTTON : ContentKeys.WINNER_POPUP_TOP100_BUTTON}
              />
            }
            onClick={() => this.handleModalClose()}
          />
        </div>
      </Modal>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators(
    {
      setMe,
      seePopup,
      setModalVisibility,
    },
    dispatch
  );
};
const mapStateToProps = (store: IStore) => {
  return {
    me: store.setMe.me,
    seePopupState: store.seePopup,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MonthlyModal);
